import React from 'react';

export default function ForgotPasswordPage() {
  return (
    <div>
      <h2>Forgot Password</h2>
    </div>
  );
}
